<template>
  <div class="menu-contacts px-4 pl-md-7 my-7 font-weight-light">
    <div class="my-2">
      <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
    </div>
    <hr class="mt-6 mr-12 d-none d-md-block">
  </div>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'TheMenuContacts',
  data() {
    return {
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style scoped lang="scss">
  .menu-contacts {
    min-width: 250px;
    color: #fff;
    hr {
      border-color: white;
      border-top: none;
      opacity: 0.12;
    }
  }
</style>
